import { isMobileOrTablet, WithBreakpointRange } from '@mews-commander/ui';
import { withBreakpointRange } from '@optimus-web/core';
import DesktopMenu, { DesktopMenuProps } from './DesktopMenu';
import MobileMenu, { MobileMenuProps } from './MobileMenu';

type LinkMenuProps = WithBreakpointRange & DesktopMenuProps & MobileMenuProps;

const LinkMenu: React.FC<LinkMenuProps> = ({ breakpointRange, ...other }) =>
    isMobileOrTablet(breakpointRange) ? <MobileMenu {...other} /> : <DesktopMenu {...other} />;

export default withBreakpointRange(LinkMenu);
